module.exports = __webpack_public_path__ + "assets/img/shannon.ae266255.png";